import { db, functions as appFunctions } from './firebaseConfig';
import { 
  doc,
  getDoc,
  setDoc,
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
  where,
  limit
} from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Re-export the main services for any component that was using this file.
export * from './firebaseConfig';

// Export Firestore utilities that were previously in this file
export {
  doc,
  getDoc,
  setDoc,
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  query,
  orderBy,
  where,
  limit
};

// Connect to Functions emulator in development (if needed by other parts of the app)
const functions = appFunctions; // Use the imported functions instance
// Temporarily disabled to use deployed functions for WhatsApp testing
// if (window.location.hostname === 'localhost') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }

// Template helpers that were in this file can remain, using the imported db
export async function saveTemplate(name, tab, blocks) {
  const templatesCol = collection(db, 'templates');
  return addDoc(templatesCol, {
    name,
    tab,
    blocks,
    createdAt: Date.now(),
  });
}

export async function loadTemplates(tab) {
  const templatesCol = collection(db, 'templates');
  const snap = await getDocs(templatesCol);
  return snap.docs
    .map(doc => ({ id: doc.id, ...doc.data() }))
    .filter(t => t.tab === tab);
}

export async function forceUpdateAllProductTextAligns() {
  const snap = await getDocs(collection(db, 'products'));
  const updates = [];
  snap.forEach(docSnap => {
    const data = docSnap.data();
    if (!data.tabs) return;
    let changed = false;
    const newTabs = {};
    for (const tabKey of Object.keys(data.tabs)) {
      const blocks = data.tabs[tabKey];
      if (!Array.isArray(blocks)) {
        newTabs[tabKey] = blocks;
        continue;
      }
      const newBlocks = blocks.map(block => {
        if (block.type === 'text' && !block.textAlign) {
          changed = true;
          return { ...block, textAlign: 'left' };
        }
        return block;
      });
      newTabs[tabKey] = newBlocks;
    }
    if (changed) {
      updates.push(updateDoc(doc(db, 'products', docSnap.id), { tabs: newTabs }));
    }
  });
  await Promise.all(updates);
  return updates.length;
}
